import { useEffect, useRef, useState } from "react"

const getScrollMetrics = () => {
  const scrollingElement = document.scrollingElement || document.documentElement

  return {
    scrollTop: window.pageYOffset || scrollingElement.scrollTop || 0,
    viewportHeight: window.innerHeight,
    documentHeight: scrollingElement.scrollHeight,
  }
}

const useRafScrollState = (getNextState, initialState = false, dependencies = []) => {
  const [state, setState] = useState(initialState)
  const stateRef = useRef(state)
  const getNextStateRef = useRef(getNextState)

  useEffect(() => {
    stateRef.current = state
  }, [state])

  useEffect(() => {
    getNextStateRef.current = getNextState
  })

  useEffect(() => {
    let frameId = null

    const update = () => {
      frameId = null
      const nextState = getNextStateRef.current(getScrollMetrics())

      if (nextState !== stateRef.current) {
        stateRef.current = nextState
        setState(nextState)
      }
    }

    const requestUpdate = () => {
      if (frameId === null) {
        frameId = window.requestAnimationFrame(update)
      }
    }

    requestUpdate()
    window.addEventListener("scroll", requestUpdate, { passive: true })
    window.addEventListener("resize", requestUpdate, { passive: true })

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId)
      }
      window.removeEventListener("scroll", requestUpdate)
      window.removeEventListener("resize", requestUpdate)
    }
  }, dependencies)

  return state
}

export default useRafScrollState
